import { Injectable } from '@angular/core';

import { GeocodeApi } from './geocode-api.service';
import {
  ListarPoblacionDto,
  ListarCodPostalDto,
  ListarPoblacionRequest,
  ListarPobCodPostalRequest,
  ListarTiposViaDto,
  NormalizarDomicilioDto,
  NormDomicilioRequest,
  NormalizarRestoDomicilioDto,
  NormRestoDomicilioRequest,
  ValidarTelefonoDto,
  PFValidarEmailRequest,
  ValidarTelefonoRequest,
  PFValidarEmailDto,
  ListarViaDto,
  ListarViaRequest,
  NormNombreRequest,
  NormalizarNombreDto,
  NormalizarPoblacionDto,
  NormPobRequest,
  NormViaRequest,
  NormalizarViaDto,
} from '../model/geocode-model';
import { FormGroup } from '@angular/forms';
import { CommonDataDTO } from '../model/combos-model';

@Injectable()
export class GeocodeStore {
  constructor(private geocodeApi: GeocodeApi) {}

  public loadListPopulation(
    dataSearch: string,
    codPostal: string,
    codPoblacion: string
  ): Promise<ListarPoblacionDto[]> | Promise<ListarCodPostalDto[]> {
    if (codPostal) {
      let listPobCodPostalRequest: ListarPobCodPostalRequest = {
        codSesion: '',
        codPostal: codPostal,
        codPoblacion: codPoblacion,
        codMunicipio: '',
        patron: dataSearch,
      };
      return new Promise<ListarCodPostalDto[]>((resolve, reject) => {
        this.geocodeApi
          .getListPopulationCodPostal(listPobCodPostalRequest)
          .toPromise()
          .then(
            (data: any) => (data ? resolve(data) : reject(data)),
            (error: any) => reject(error)
          );
      });
    } else {
      let listPopulationRequest: ListarPoblacionRequest = {
        codSesion: '',
        codProvincia: '',
        patron: dataSearch,
        literales: '',
        minusculas: '',
      };
      return new Promise<ListarPoblacionDto[]>((resolve, reject) => {
        this.geocodeApi
          .getListPopulation(listPopulationRequest)
          .toPromise()
          .then(
            (data: any) => (data ? resolve(data) : reject(data)),
            (error: any) => reject(error)
          );
      });
    }
  }

  public loadListTypeVia(): Promise<ListarTiposViaDto[]> {
    return new Promise<ListarTiposViaDto[]>((resolve, reject) => {
      this.geocodeApi
        .getListTypeVia()
        .toPromise()
        .then(
          (data: any) => resolve(data),
          (error: any) => reject(error)
        );
    });
  }

  public loadListVia(search: string, poblacionSelected: CommonDataDTO, trackType: string): Promise<ListarViaDto[]> {
    let request: ListarViaRequest = {
      codSesion: '',
      codPoblacion: poblacionSelected.id,
      patron: search,
      tipoVia: trackType,
      codPostal: '',
      minusculas: '',
    };
    return new Promise<ListarViaDto[]>((resolve, reject) => {
      this.geocodeApi
        .getListVia(request)
        .toPromise()
        .then(
          (data: any) => resolve(data),
          (error: any) => reject(error)
        );
    });
  }

  public normalizarDomicilio(form: FormGroup): Promise<NormalizarDomicilioDto> {
    let request: NormDomicilioRequest = {
      codPoblacion: '',
      desPoblacion: form.controls.town.value,
      codPostal: form.controls.postalCode.value,
      codProvincia: '',
      desProvincia: '',
      tipoVia: form.controls.trackType.value === 'CALLE' ? '' : form.controls.trackType.value,
      desVia: form.controls.address.value?.split(' (')[0],
      numPortal: form.controls.number.value,
      restoDomicilio: form.controls.floor.value + ' ' + form.controls.door.value,
      minusculas: '',
      anyoSeccionCensal: '',
      sistemaCoordenadas: '',
    };
    return new Promise<NormalizarDomicilioDto>((resolve, reject) => {
      this.geocodeApi
        .postNormalizarDomicilio(request)
        .toPromise()
        .then(
          (data: NormalizarDomicilioDto) => resolve(data),
          (error: any) => reject(error)
        );
    });
  }

  public normalizarRestoDomicilio(form: FormGroup): Promise<NormalizarRestoDomicilioDto[]> {
    let request: NormRestoDomicilioRequest = {
      codSesion: '',
      restoDomicilio:
        form.controls.addressComplement.value + ' ' + form.controls.floor.value + ' ' + form.controls.door.value,
      numPortal: '',
    };
    return new Promise<NormalizarRestoDomicilioDto[]>((resolve, reject) => {
      this.geocodeApi
        .postNormalizarRestoDomicilio(request)
        .toPromise()
        .then(
          (data: any) => resolve(data),
          (error: any) => reject(error)
        );
    });
  }

  public validarEmail(email: string): Promise<PFValidarEmailDto> {
    let request: PFValidarEmailRequest = {
      codSesion: '',
      email: email,
      listaExclusion: 'S',
      corregirEmail: 'N',
    };
    return new Promise<PFValidarEmailDto>((resolve, reject) => {
      this.geocodeApi
        .postValidarEmail(request)
        .toPromise()
        .then(
          (data: PFValidarEmailDto) => resolve(data),
          (error: any) => reject(error)
        );
    });
  }

  public validarPhone(phone: string): Promise<ValidarTelefonoDto> {
    let request: ValidarTelefonoRequest = {
      codSesion: '',
      numTelefono: phone,
    };
    return new Promise<ValidarTelefonoDto>((resolve, reject) => {
      this.geocodeApi
        .postValidarTelefono(request)
        .toPromise()
        .then(
          (data: ValidarTelefonoDto) => resolve(data),
          (error: any) => reject(error)
        );
    });
  }

  public normalizarNombre(name: string, surname1: string, surname2: string): Promise<NormalizarNombreDto> {
    let request: NormNombreRequest = {
      codSesion: '',
      nombre: name,
      apellido1: surname1,
      apellido2: surname2,
      noremp: '',
      dics: '',
      noape: '',
      minusculas: '',
    };
    return new Promise<NormalizarNombreDto>((resolve, reject) => {
      this.geocodeApi
        .postNormalizarNombre(request)
        .toPromise()
        .then(
          (data: NormalizarNombreDto) => resolve(data),
          (error: any) => reject(error)
        );
    });
  }

  public normalizarPoblacion(data: string, codPoblacion?: string): Promise<NormalizarPoblacionDto> {
    let request: NormPobRequest = {
      codSesion: '',
      desPoblacion: codPoblacion ? '' : data,
      codPostal: '',
      desProvincia: '',
      codProvincia: '',
      codPoblacion: codPoblacion,
      minuscula: '',
    };
    return new Promise<NormalizarPoblacionDto>((resolve, reject) => {
      this.geocodeApi
        .postNormalizarPoblacion(request)
        .toPromise()
        .then(
          (data: NormalizarPoblacionDto) => resolve(data),
          (error: any) => reject(error)
        );
    });
  }

  public normalizarVia(form: FormGroup, poblacionSelected: CommonDataDTO): Promise<NormalizarViaDto> {
    let request: NormViaRequest = {
      codSesion: '',
      tipoVia: '',
      desVia: form.controls.address.value?.split(' (')[0],
      numPortal: form.controls.number.value,
      restoDomicilio: '',
      codPoblacion: poblacionSelected.id,
      desPoblacion: poblacionSelected.value,
      codPostal: '',
      minusculas: '',
    };
    return new Promise<NormalizarViaDto>((resolve, reject) => {
      this.geocodeApi
        .postNormalizarVia(request)
        .toPromise()
        .then(
          (data: NormalizarViaDto) => resolve(data),
          (error: any) => reject(error)
        );
    });
  }
}
